import styled from "styled-components/native";
import { View } from "react-native";
import { padding } from "styled-system";

export const StyledView = styled(View)<{ isFullHeight?: boolean }>`
  ${({ isFullHeight }: { isFullHeight?: boolean }) =>
    isFullHeight && "flex-grow:1"};
  ${padding};
`;
